import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

export const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

export function getErrorMessage(error) {
  return error?.response?.data?.message || error?.message || "Something went wrong";
}

